export default __webpack_public_path__ + "static/media/NEAR-BNB.1b650b37.svg";